import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MuiAlert from '@material-ui/lab/Alert';
import { Snackbar } from '@material-ui/core';
import { FormikProps, FormikValues, useFormikContext } from 'formik';
import { BaseStudentFormEntry } from 'components/ClassroomsModule/types';
import useDefaultGroupSetting from 'components/ClassroomsModule/hooks/use-default-group-settings';
import useStore from 'store';

const GroupAssignmentAlert = () => {
  const { t } = useTranslation('Groups');
  const [{ productCache }] = useStore();
  const { getProductCurriculumDefaultGroupSettings } = useDefaultGroupSetting();
  const { values }: FormikProps<FormikValues> = useFormikContext();

  const students = values?.students ? values?.students : values?.ADD_STUDENTS?.students;
  const assignedProductCurriculumIds: number[] = students.flatMap(
    (student: BaseStudentFormEntry) => student.licenses?.map(l => l.productCurriculumId) ?? []
  );
  const defaultGroupSettings = getProductCurriculumDefaultGroupSettings(
    assignedProductCurriculumIds
  );

  const productCodesWithGroups = [...new Set(defaultGroupSettings.flatMap(d => d.productCodes))];
  const productNames = productCodesWithGroups
    .reduce((acc, productCode) => {
      const product = productCache.findProductByProductCode(productCode);
      return product ? [...acc, product.name] : acc;
    }, [] as string[])
    .join(', ');

  const [isOpen, setIsOpen] = useState(defaultGroupSettings.length > 0);
  const handleClose = (): void => {
    setIsOpen(false);
  };

  return (
    <Snackbar open={isOpen} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <MuiAlert severity="warning" onClose={handleClose}>
        {t(
          'All students with an {{productNames}} license will automatically be assigned a group based on their grade. Please review and make any necessary changes.',
          { productNames }
        )}
      </MuiAlert>
    </Snackbar>
  );
};

export default GroupAssignmentAlert;
